import React from 'react';

import SharedEdit from 'shared/components/Entities/ReferralChecklistTemplate/Edit';

const Edit = props => (
  <SharedEdit entityId={props.params.entityId} apiPrefix={`/agent_portal/api`} />
);

export default Edit;
